module.exports = __webpack_public_path__ + "static/media/Artboard6.5bf95595.png";